import './tripsDetails.css';
import {Link, NavLink, useParams} from "react-router-dom";
import DriverInfo from "../../components/driverInfo/driverInfo";
import VideoSec from "../../components/videoSec/videoSec";

import TripFactorDetails from "../../components/tripFactorDetails/tripFactorDetails";
import TripStops from "../../components/tripStops/tripStops";
import {useEffect, useRef, useState} from "react";
import Slider from "../../shared/slider/slider";
import TripDetailsMap from "../../components/tripDetailsComponent/tripDetailsMap/tripDetailsMap";
import {differenceInSeconds, format} from "date-fns";
import $ from 'jquery';
import expandIcon from '../../assets/images/expand-start.svg';

import TripsDetailsService from "../../services/tripsDetails.service";
import Loaders from "../../shared/loaders/loaders";
import VideoPlayer from "../../shared/videoPlayer/videoPlayer";


const TripsDetails = () => {
    const {id} = useParams();
    const [showLoader, setShowLoader] = useState(false);
    const [tripDetails, setTripDetails] = useState();
    const [tripMapData, setTripMapData] = useState({
        tripCords: [],
        alerts: []
    });
    const [panToLatLng, setPanToLatLng] = useState({});
    const [alertsLoader, setAlertsLoader] = useState(false);
    const [criticalVideos, setCriticalVideos] = useState([]);
    const [criticalVideosLoader, setCriticalVideosLoader] = useState(true);
    const [DVRVideoPathNodes, setDVRVideoPathNodes] = useState([]);
    const [DVRPathSliderNodes, setDVRPathSliderNodes] = useState([1, 2]);
    const [selectedAlert, setSelectedAlert] = useState();
    const [showVideoPlayer, setShowVideoPlayer] = useState(false);
    const [videoPlayerData, setVideoPlayerData] = useState({
        player: {},
        other: {}
    });
    const [expandMap, setExpandMap] = useState(false);
    const [tripInfoOverflow, setTripInfoOverflow] = useState(false);
    const videoSecRef = useRef();
    const mapRef = useRef();
    const MAX_DVR_TIME_PERIOD_IN_SECONDS = 180;

    const userAlerts = (JSON.parse(localStorage.getItem("user-details")))?.skuDetails?.alerts || [];

    const handleActivateAlertsClick = (alertString) => {
        let newTripMapData = {...tripMapData};
        newTripMapData?.alerts?.forEach(alert => {
            if (!alertString || alertString === "")
                alert.isActive = null;
            else
                alert.isActive = alert.alertType === alertString;

        })
        setTripMapData(newTripMapData);
    }

    const getTripDetails = async () => {
        setCriticalVideosLoader(true);
        setAlertsLoader(true);
        const userDetails = JSON.parse(localStorage.getItem("user-details"));
        const response = await TripsDetailsService.getTripDetails(id);
        const tripCords = response?.locations?.map((loc) => {
            return {
                timestamp: loc?.timeStamp,
                timestampInISO: loc?.timeStampInISO,
                lat: +loc.location.coordinates[1],
                lng: +loc.location.coordinates[0]
            }
        })
        setTripDetails(response);
        setTripMapData((prevState) => {
            return {
                ...prevState,
                tripCords: tripCords,
                alerts: response?.alerts
            }
        })
        setCriticalVideos(response?.alerts || []);
        setCriticalVideosLoader(false);
        setAlertsLoader(false);
        const centerCord = Math.round(tripCords?.length / 2);
        if (tripMapData && tripMapData?.tripCords?.length > 0) {
            let [start, end] = restrictSliderToMaxDvrSeconds({
                isLastSlider: true,
                values: [1, centerCord]
            })
            setDVRPathSliderNodes([start, end])
        }

    }

    const getSelectedAlert = (alert) => {
        setSelectedAlert(alert);
    }
    const handleAlertClick = (alert) => {
        setSelectedAlert(alert);
        const cord = alert?.location?.coordinates;
        setPanToLatLng({lat: cord[1], lng: cord[0]});
    }

    const restrictSliderToMaxDvrSeconds = (payload) => {
        let [windowStart, windowEnd] = payload.values;

        windowStart = Math.max(0, windowStart);
        windowEnd = Math.min(tripMapData?.tripCords?.length - 1, windowEnd)

        let startPoint = tripMapData?.tripCords[windowStart];
        let endPoint = tripMapData?.tripCords[windowEnd];
        let diff = differenceInSeconds(endPoint.timestamp, startPoint.timestamp)

        if (diff > MAX_DVR_TIME_PERIOD_IN_SECONDS) {
            while (diff > MAX_DVR_TIME_PERIOD_IN_SECONDS && windowStart < windowEnd && payload?.isLastSlider) {
                startPoint = tripMapData?.tripCords[windowStart];
                diff = differenceInSeconds(endPoint.timestamp, startPoint.timestamp);
                windowStart++;
            }

            while (diff > MAX_DVR_TIME_PERIOD_IN_SECONDS && windowEnd > windowStart && !payload?.isLastSlider) {
                endPoint = tripMapData?.tripCords[windowEnd];
                diff = differenceInSeconds(endPoint.timestamp, startPoint.timestamp);
                windowEnd--;
            }
        }
        windowStart = Math.max(0, windowStart);
        windowEnd = Math.min(tripMapData?.tripCords?.length - 1, windowEnd);
        return [windowStart, windowEnd];
    }

    const getDVRVideoPath = (payload) => {
        let [windowStart, windowEnd] = restrictSliderToMaxDvrSeconds(payload);
        $(payload.sliderObject).slider({values: [windowStart, windowEnd]});
        payload.setSliderValue([windowStart, windowEnd]);
        getDVRVideoPathNodes([windowStart, windowEnd]);
    }

    const getDVRVideoPathNodes = (nodes) => {
        const DVRVideoNodes = [];
        if (tripMapData?.tripCords?.length > 0) {
            for (let i = nodes[0]; i <= nodes[1]; i++) {
                DVRVideoNodes.push(tripMapData?.tripCords[i]);
            }
            setDVRVideoPathNodes(DVRVideoNodes);
        }
        let centerOfMapIdx = DVRVideoNodes.length >> 1;
        setPanToLatLng({lat: DVRVideoNodes[centerOfMapIdx]?.lat, lng: DVRVideoNodes[centerOfMapIdx]?.lng});
    }

    const handleShowVideoPlayer = (val, videoData, alertData) => {
        setShowVideoPlayer(val);
        setVideoPlayerData((prevState) => {
            return {
                ...prevState,
                player: videoData,
                other: alertData
            }
        });
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }

    const handleRequestDVR = () => {
        if (DVRVideoPathNodes.length < 2)
            return;
        const nodes = DVRVideoPathNodes[0];
        const lastNode = DVRVideoPathNodes[DVRVideoPathNodes.length - 1];

    }

    const driverInfo = [
        {
            text: 'Ramesh Jagannath',
            class: 'sf-bold'
        },
        {
            text: 'ID: 6885',
            class: ''
        },
        {
            text: 'BharathBenz HDT R  - 30 Tons',
            class: ''//'sf-bold'
        },
        {
            text: 'KA 02  N 9023',
            class: ''
        },
        {
            text: 'Model: 2017 ',
            class: ''
        },
    ];

    const handleExpandMap = () => {
        setTripInfoOverflow(true)
        setExpandMap((prevState) => {
            return !prevState
        });
        const tripInfoTimer = setTimeout(() => {
            setTripInfoOverflow(false);
            clearTimeout(tripInfoTimer);
        }, 300);
    }


    useEffect(() => {
        getTripDetails();
    }, [])

    useEffect(() => {
        getDVRVideoPathNodes(DVRPathSliderNodes);
    }, [DVRPathSliderNodes]);


    return (
        <div className={'content-section trip-details-sec page-fade-in'}>
            <div className="round-corner-8 padding-tb-20 flex hr-space-between ">
                <Link to=".." relative={'path'} className="flex font-15 gap-10">
                    <div className="back-btn-circular"></div>
                    <div className="highlight-color sf-medium">Back</div>
                </Link>
                {/*<div className="flex">*/}
                {/*    <DateRangePicker selectRange={true} classes={'date width-300 item-height-40'}/>*/}
                {/*    <CalendarType/>*/}
                {/*</div>*/}
            </div>

            <div className="">
                <div className={`data-table trips-list-table font-17`}>
                    <ul className="table-row sf-medium table-header light-back grey-color border-radius-8">
                        <li className={'from'}>From</li>
                        <li className={'to'}>To</li>
                        <li className={'tripId'}>Trip ID</li>
                        <li className={'number-plate'}>Vehicle Plate No</li>
                        <li className={'date-time'}>Date & Time</li>
                        <li className={'distance'}>Distance</li>
                        <li className={'duration'}>Duration</li>
                        {/*<li className={'fuel-consumed'}>Fuel Consumed</li>*/}
                        <li className={'alerts'}>Alerts</li>
                        <li className={'score'}>Score</li>
                    </ul>
                    <ul className="table-row padding-tb-10 sf-bold border-bottom">
                        <li className={'from'}>Chennai</li>
                        <li className={'to'}>Madurai</li>
                        <li className={'tripId'}>
                            <div className=''>
                                <div className="text-ellipsis">{tripDetails?._id}</div>
                                <div className="tooltip">{tripDetails?._id}</div>
                            </div>
                        </li>
                        <li className={'number-plate'}>{tripDetails?.vehicle?.plateNo}</li>
                        <li className={'date-time'}>
                            {tripDetails?.startTimeInISO &&
                                <span>{format(new Date(`${tripDetails?.startTimeInISO}`), 'MMM dd, hh:mm')}</span>
                            }
                            <span className={'margin-lr-5'}> - </span>
                            {tripDetails?.endTimeInISO &&
                                <span>{format(new Date(`${tripDetails?.endTimeInISO}`), 'MMM dd, hh:mm')}</span>
                            }
                        </li>
                        <li className={'distance'}>{((tripDetails?.distance?.value || 0) / 1000).toFixed(1)} KMs</li>
                        <li className={'duration'}>{((tripDetails?.duration?.value || 0) / (1000 * 60 * 60)).toFixed(1)} Hrs</li>
                        <li className={'alerts'}>{tripDetails?.alerts?.length}</li>
                        <li className={'date-time flex'}>
                            <div className="progress-bar item-height-6 width-60">
                                <div className="completed"></div>
                            </div>
                            <div className="margin-l-10">{Math.round(Math.random() * (99 - 80)) + 80}</div>
                        </li>
                    </ul>
                </div>
            </div>

            {/*....... driver details .......*/}
            <div className="border-bottom margin-b-40 light-back">
                <DriverInfo data={driverInfo}/></div>

            {/*....... video section ......*/}
            <div className="margin-b-40">
                {criticalVideos?.length > 0 &&
                    <div className="section-title margin-b-20">Critical Alert Videos for this trip</div>
                }
                <VideoSec ref={videoSecRef}
                          tripId={tripDetails?._id}
                          alerts={criticalVideos}
                          loader={criticalVideosLoader}
                          selectedAlert={selectedAlert}
                          onVideoClick={handleShowVideoPlayer}/>
            </div>

            <div className={`trip-map-sec ${expandMap ? 'expandMap' : ''}`}>
                <div className="section-title margin-b-20">Map</div>
                <div className="flex align-top">
                    <div className="map-sec relative" id="map-sec">
                        <div className='flex  hr-space-between'>
                            <ul className={'trip-list map-overlay font-14'}>
                                <li className={'flex hr-space-between sf-medium'}>
                                    <div className={'flex gap-50'}>
                                        <div className="flex gap-10 font-15">
                                            <div className={'from'}>Bangalore</div>
                                            <div className="connector"></div>
                                            <div className="to">Chennai</div>
                                        </div>
                                        {/*<div className="">*/}
                                        {/*    Driver: Babu K*/}
                                        {/*</div>*/}
                                    </div>
                                    <ul className="separator font-14 gap-20">
                                        <li>{((tripDetails?.distance?.value || 0) / 1000).toFixed(1)} KMs</li>
                                        <li>{((tripDetails?.duration?.value || 0) / (1000 * 60 * 60)).toFixed(1)} Hrs</li>
                                    </ul>
                                </li>
                            </ul>
                            <div className='expandMapIcon icon' onClick={handleExpandMap}>
                                <img src={expandIcon} alt="Expand Icon"></img>
                            </div>
                        </div>
                        <div className="trip-details-map margin-b-20">
                            <TripDetailsMap
                                ref={mapRef}
                                tripMapData={tripMapData}
                                tripId={tripDetails?._id}
                                DVRVideoPathNodes={DVRVideoPathNodes}
                                getSelectedAlert={getSelectedAlert}
                                selectedAlert={selectedAlert}
                                panToLatLng={panToLatLng}
                                onAlertVideoClick={handleShowVideoPlayer}/>
                        </div>
                        <div className="flex hr-space-between map-slider-box margin-b-30">
                            <div className="map-slider">
                                {tripMapData?.tripCords?.length > 0 &&
                                    <Slider min={0}
                                            max={tripMapData?.tripCords?.length}
                                            range={true}
                                            onChange={getDVRVideoPath}
                                            value={DVRPathSliderNodes}/>
                                }
                            </div>
                            <div className="btn item-height-40 round-corner-8 font-14"
                                 onClick={e => handleRequestDVR()}>
                                Request DVR Video
                            </div>
                        </div>

                        <ul className="alerts-full-form flex flex-wrap font-15">
                            {userAlerts.map((cat) =>
                                <li key={cat?.displayString} className={`flex gap-0`}>
                                    <div className="">{cat?.type.slice(0, 3)}:</div>
                                    <div className="margin-l-5 grey-color">{cat?.displayString}</div>
                                </li>
                            )}
                        </ul>

                    </div>
                    <div className={`trip-info-sec ${tripInfoOverflow ? 'hide-overflow' : ''}`}
                         id="trip-info-sec">
                        <div className="margin-b-30">
                            <TripFactorDetails alerts={tripMapData?.alerts} loader={alertsLoader}
                                               onAlertClick={handleActivateAlertsClick}/>
                        </div>
                        <div className="">
                            <TripStops
                                alerts={tripDetails?.alerts}
                                loader={alertsLoader}
                                getSelectedAlert={handleAlertClick}
                                selectedAlert={selectedAlert}/>
                        </div>
                    </div>
                </div>
            </div>
            {showVideoPlayer &&
                <VideoPlayer videoData={videoPlayerData} handleShowVideoPlayer={handleShowVideoPlayer}/>
            }
        </div>
    )
}

export default TripsDetails;
